import React, { useMemo } from 'react';
import { Resource, ResourceInfo } from 'omni-package-react-core';
import { getIdentityManagementApiRoot } from 'we-package-react-account';
import transformOnboarding from './transformOnboarding';

export const OnboardingResourceInfo: ResourceInfo = {
  name: '/App.features.account.OnboardingResource',
  dataDst: '/App.features.account.onboarding',
};

const OnboardingResource = () => {
  const url = useMemo(() => `${getIdentityManagementApiRoot('centralized-auth')}/onboarding`, []);

  return (
    <Resource
      {...OnboardingResourceInfo}
      url={url}
      transformResponse={transformOnboarding}
      autoRequestIfEmpty
    />
  );
};

export default OnboardingResource;
